export class ChangePasswordRequest{
  password: string;

  constructor(password: string){
    this.password = password;
  }
}
